var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 285.938 285.938",
    style: {
      enableBackground: "new 0 0 285.938 285.938"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M217.969,103.125h-46.875v9.375h46.875c7.753,0,14.063,6.309,14.063,14.063v18.872 c-3.928-2.977-8.766-4.809-14.063-4.809h-150c-7.753,0-14.063-6.309-14.063-14.063s6.31-14.063,14.063-14.063h51.563v-9.375 H67.969c-12.923,0-23.438,10.514-23.438,23.438V262.5c0,12.923,10.514,23.438,23.438,23.438h150 c12.923,0,23.438-10.514,23.438-23.438v-14.063v-65.625v-18.75v-37.5C241.406,113.639,230.892,103.125,217.969,103.125z  M232.031,239.063h-56.25c-12.923,0-23.438-10.514-23.438-23.438s10.514-23.438,23.438-23.438h56.25V239.063z M232.031,182.813 h-56.25c-18.094,0-32.813,14.723-32.813,32.813s14.719,32.813,32.813,32.813h56.25V262.5c0,7.753-6.309,14.063-14.063,14.063h-150 c-7.753,0-14.063-6.309-14.063-14.063V145.303c3.919,2.948,8.789,4.697,14.063,4.697h150c7.753,0,14.063,6.309,14.063,14.063 V182.813z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.969,
    y: 121.875,
    style: {
      fill: "#ffffff"
    },
    width: 150,
    height: 9.375
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9BA48"
    },
    cx: 142.969,
    cy: 89.063,
    r: 37.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M147.656,103.125h-9.375c-2.583,0-4.688-2.105-4.688-4.688h-9.375 c0,7.753,6.309,14.063,14.063,14.063v4.688h9.375V112.5c7.753,0,14.063-6.309,14.063-14.063s-6.309-14.063-14.063-14.063h-9.375 c-2.583,0-4.688-2.105-4.688-4.688S135.698,75,138.281,75h9.375c2.583,0,4.688,2.105,4.688,4.688h9.375 c0-7.753-6.309-14.063-14.063-14.063v-4.688h-9.375v4.688c-7.753,0-14.063,6.309-14.063,14.063s6.309,14.063,14.063,14.063h9.375 c2.583,0,4.688,2.105,4.688,4.688S150.239,103.125,147.656,103.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M161.719,215.625c0,7.753,6.309,14.063,14.063,14.063s14.063-6.309,14.063-14.063 s-6.309-14.063-14.063-14.063S161.719,207.872,161.719,215.625z M180.469,215.625c0,2.587-2.105,4.688-4.688,4.688 s-4.688-2.1-4.688-4.688s2.105-4.688,4.688-4.688S180.469,213.038,180.469,215.625z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.281,
    style: {
      fill: "#ffffff"
    },
    width: 9.375,
    height: 37.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.094,
    y: 14.063,
    style: {
      fill: "#ffffff"
    },
    width: 9.375,
    height: 37.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.469,
    y: 23.438,
    style: {
      fill: "#ffffff"
    },
    width: 9.375,
    height: 28.125
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.63b172720775946c40dd6a23a78d4f51.svg";
export { ForwardRef as ReactComponent };